module.exports = __webpack_public_path__ + "static/img/rank3.32b5d415.png";